import { AnimatePresence, motion } from "framer-motion";
import Image from "next/image";
import { useEffect, useRef } from "react";

type BottomSheetProps = {
    isOpen: boolean;
    children: React.ReactNode;
    className?: string;
    onClose?: () => void;
    height?: string;
};

const BottomSheet: React.FC<BottomSheetProps> = ({ isOpen, height, children, className, onClose }) => {
    const bottomSheetRef = useRef<HTMLDivElement>(null)
    const bottomSheetVariants = {
        open: { y: 0 },
        closed: { y: "100%" },
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (bottomSheetRef.current && !bottomSheetRef.current.contains(event.target as Node)) {
            handleClose();
        }
    };

    useEffect(() => {
        // Attach the listener to the document when the component is mounted
        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup the listener when the component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    return (
        <AnimatePresence>
            {isOpen && (
                <motion.div
                    initial="closed"
                    animate="open"
                    exit="closed"
                    variants={bottomSheetVariants}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    className={`fixed inset-x-0 bottom-0 overflow-y-scroll z-50 ${className}`}
                    style={{ height: height }}

                >
                    <div ref={bottomSheetRef} className="flex flex-col">
                        {children}
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

export default BottomSheet;
